import { createFileRoute, redirect } from "@tanstack/react-router";

/** A former space address, kept because a pasted address may never stop resolving. */
export const Route = createFileRoute("/s/$code")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/$address", params: { address: params.code } });
  },
});
